














































































































import { defineComponent, inject } from '@vue/composition-api'

import '../../images/shop_icon.svg'
import '../../images/external_icon.svg'
import { StoreKey as FormStoreKey } from '../../store/Form'
import { StoreKey as InputStoreKey } from '../../store/Input'
import { StoreKey as ValidatedStoreKey } from '../../store/Validated'
import { StoreKey as ErrorStoreKey } from '../../store/Error'

export default defineComponent({
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }

        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }

        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }

        const shopSelectHandler = (contactId) => {
            inputStore.shop = contactId
            errorStore.shop.value = null
            validatedStore.shop = 1

            const target = document.querySelector('#_form_system_customer_info')
            if (target) {
                const rect = target.getBoundingClientRect()

                window.scrollTo({
                    top: rect.top + window.pageYOffset,
                    left: 0,
                    behavior: 'smooth',
                })
            }
        }

        return {
            formStore,
            shopSelectHandler,
        }
    },
})
